import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { firstValueFrom } from 'rxjs';
import { PageControl } from '../interface';

@Injectable({
  providedIn: 'root'
})
export class PageControlsService {

  constructor(private _http: HttpService) { }

  public getAll(): Promise<PageControl[]> {
    return firstValueFrom(this._http.get('/PageControls/'));
  }

  public get(id: number): Promise<PageControl> {
    return firstValueFrom(this._http.get('/PageControls/' + id));
  }

  public create(data: PageControl): Promise<PageControl> {
    return firstValueFrom(this._http.post('/PageControls', data));
  }

  public update(id: number, data: PageControl): Promise<PageControl> {
    return firstValueFrom(this._http.patch('/PageControls/', id, data));
  }

  public delete(id: number): Promise<PageControl> {
    return firstValueFrom(this._http.delete('/PageControls/', id));
  }
}
